<script setup lang="ts">
import { DotsVerticalIcon } from "@gohighlevel/ghl-icons/24/outline";
import {
  RTEControlBlockQuote,
  RTEControlResetStyles,
  RTEControlSubscript,
  RTEControlSuperscript,
} from "@gohighlevel/ghl-text-editor";
import { MenuButton, Menu as MenuComp, MenuItems } from "@headlessui/vue";
import { Editor } from "@tiptap/vue-3";
import OverflowMenuItem from "./OverflowMenuItem.vue";
import { useI18n } from "vue-i18n";

const { t } = useI18n();
interface Props {
  editor: Editor;
}

defineProps<Props>();
</script>

<template>
  <MenuComp as="div" class="relative">
    <MenuButton>
      <DotsVerticalIcon class="h-5 text-gray-600" />
    </MenuButton>
    <Transition
      enter-active-class="transition duration-100 ease-out origin-bottom"
      enter-from-class="origin-bottom transform scale-95 opacity-0"
      enter-to-class="origin-bottom transform scale-100 opacity-100"
      leave-active-class="transition duration-75 ease-in origin-bottom"
      leave-from-class="origin-bottom transform scale-100 opacity-100"
      leave-to-class="origin-bottom transform scale-95 opacity-0"
    >
      <MenuItems
        class="overflow-menu absolute origin-bottom bg-white p-2 shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none"
      >
        <hr class="overflow-menu-partition" />
        <OverflowMenuItem>
          <RTEControlSuperscript :editor="editor" tooltip-label="Superscript" />
        </OverflowMenuItem>
        <OverflowMenuItem>
          <RTEControlSubscript :editor="editor" tooltip-label="Subscript" />
        </OverflowMenuItem>
        <hr class="overflow-menu-partition" />
        <OverflowMenuItem>
          <RTEControlBlockQuote :editor="editor" tooltip-label="Block quote" />
        </OverflowMenuItem>
        <hr class="overflow-menu-partition" />
        <OverflowMenuItem :label="t('textEditor.resetStyle')">
          <RTEControlResetStyles :editor="editor" />
        </OverflowMenuItem>
        <OverflowMenuItem :label="t('textEditor.resetDocumentStyle')">
          <RTEControlResetStyles :editor="editor" reset="document" />
        </OverflowMenuItem>
      </MenuItems>
    </Transition>
  </MenuComp>
</template>

<style scoped>
.overflow-menu {
  bottom: 2rem;
  left: -0.5rem;
  z-index: 20;
}
.overflow-menu-partition {
  border: 0;
  border-top: 1px solid #e5e7eb;
  margin: 4px 0; /* keep spacing even with menu items (my-1 ~ 4px) */
  height: 0;
}
button {
  background-color: transparent;
  border: none;
  cursor: pointer;
}
</style>
